"use client";

import React, { ReactElement } from "react";
import { SiteType } from "@/types";
import { SharedAboutPanel, MissionPanel } from "@/components";
import { useAtomValue } from "jotai";
import { filterSitesByMission } from "@/utils";
import { aboutPanelVisibilityAtom, missionAtom } from "@/store";

interface MovablePanelListProps {
  sites: SiteType[];
}

function SharedMovablePanelList({
  sites,
}: Readonly<MovablePanelListProps>): ReactElement {
  const about = useAtomValue(aboutPanelVisibilityAtom);
  const mission = useAtomValue(missionAtom);
  const missionSites = mission ? filterSitesByMission(sites, mission) : [];

  return (
    <div className="static z-20">
      {about ? <SharedAboutPanel /> : null}
      {mission ? <MissionPanel mission={mission} sites={missionSites} /> : null}
    </div>
  );
}

export { SharedMovablePanelList };
